import * as Sentry from '@sentry/browser';

import { PAYMENTS_API_URL } from 'data/constants';
import { Deposit } from 'data/payments/models';
import { AnalyticsEvents, trackEvent } from 'utils/analytics';
import { parseItemStrict } from 'utils/parser/parseResponse';

export async function getPayment(depositId: string) {
  const result = await fetch(
    `${PAYMENTS_API_URL}/public/payments/${depositId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (result.status > 399) {
    const responseBody = await result.text();
    const error = new Error(`Failed to get payment status: ${responseBody}`);

    Sentry.captureException(error);
    trackEvent(AnalyticsEvents.PAYMENT_ERROR, {
      order_id: depositId,
      error_type: 'api_error',
      error_code: `${String(result.status)} ${result.statusText}`,
      error_message: error.message + ' ' + error.name,
      http_status: String(result.status),
    });
    throw error;
  }

  // Must go below previous response reading (in case of error)
  const data = await result.json();

  if (data.status === 'PAID' || data.status === 'EXPIRED') {
    trackEvent(AnalyticsEvents.PAYMENT_RESULT, {
      order_id: depositId,
      payment_method: data.method,
      status: data.status,
      amount_base: data.amount ?? '',
    });
  }

  return parseItemStrict(Deposit, { id: depositId, ...data });
}
